import React from 'react';

import {
  Form,
  Input,
  FormGroup,
  Label,
  Col,
  Button
} from 'reactstrap';
import { MdSearch } from 'react-icons/lib/md';

const PesquisaAutoInfracaoForm = ({ buscarInfracao, exibirMensagem, fecharMensagem, mensagem }) => {
  const pesquisar = evento => {
    evento.preventDefault();
    const form = evento.target;
    const formValido = (form.auto.value && form.codigo.value);
    if (!formValido) {
      return exibirMensagem({ msg: "Preencha os campos solicitados.", tipo: "warning" });
    }
    buscarInfracao(form.auto.value, form.codigo.value);
    fecharMensagem();
  }
  return (
    <Form onSubmit={pesquisar}>
      <FormGroup row>
        <Col lx={3}>
          <Label for="auto" className="lbl-required">Auto de Infração</Label>
          <Input name="auto" type="search" placeholder="ex: 00000JJJ09" />
        </Col>
        <Col lx={2}>
          <Label for="cod"  className="lbl-required">Cód. de infração</Label>
          <Input name="codigo" type="search" placeholder="ex: 5061" />
        </Col>
        <Col lx={1} className="col-button">
          <Button>
            <MdSearch size="20" />
            Pesquisar
          </Button>
        </Col>
      </FormGroup>
    </Form>
  );
};

export default PesquisaAutoInfracaoForm;



// WEBPACK FOOTER //
// ./src/componentes/PesquisaAutoInfracaoForm.js